export const shouldClearEditorForAGEDETAIL = (formula: string): boolean => {
  const paramsMatch = formula.match(/AGEDETAIL\(([^)]+)\)/)
  if (!paramsMatch) return false

  const paramsString = paramsMatch[1]
  const params = new URLSearchParams(paramsString.replace(/,/g, '&'))

  const onlyNumber = params.get('only_number')
  const includeMonths = params.get('include_months')

  return (
    (onlyNumber === 'false' && includeMonths === 'false') ||
    (onlyNumber === 'true' && includeMonths === 'true') ||
    (onlyNumber === 'false' && includeMonths === 'true')
  )
}
